module.exports = __webpack_public_path__ + "img/picture_s2examinationvideo3@2x.6aa3fb21.png";